import * as React from 'react';
import { Routes, Page, getPage } from 'constants/pages';
import {
  BoltIcon,
  PresentationChartLineIcon,
  HomeIcon,
  TrashIcon,
} from '@heroicons/react/24/solid';
import { checkForPermission, usePermissions } from 'utils/permissions';
import { useIsDashboardUser } from 'utils/permissions/hooks';
import { FeatureFlag, useFeatureFlag } from 'utils/permissions/feature-flags';

export const usePages: () => Page[] = () => {
  const permissions = usePermissions();
  const dashboardIsHome = useIsDashboardUser();

  const showHistoricalLink = useFeatureFlag(FeatureFlag.AccessHistoricalPerDiem);

  const pages = React.useMemo(() => {
    const items = [
      {
        title: 'Dashboard',
        page: getPage(Routes.ShipmentsDashboard),
        path: Routes.ShipmentsDashboard,
        PageIcon: dashboardIsHome ? (
          <HomeIcon style={{ width: 20 }} />
        ) : (
          <PresentationChartLineIcon style={{ width: 20 }} />
        ),
      },
      ...(showHistoricalLink
        ? [
            {
              title: 'Historical Reporting',
              page: getPage(Routes.ShipmentsReports),
              path: Routes.ShipmentsReports,
              PageIcon: <PresentationChartLineIcon style={{ width: 20 }} />,
            },
          ]
        : []),
      {
        title: 'Active Shipments',
        page: getPage(Routes.ShipmentsActive),
        path: Routes.ShipmentsActive,
        PageIcon: <BoltIcon style={{ width: 18 }} />,
      },
      {
        title: 'Deleted Shipments',
        page: getPage(Routes.ShipmentsDeleted),
        path: Routes.ShipmentsDeleted,
        PageIcon: <TrashIcon style={{ width: 18 }} />,
      },
    ];
    const filtered = items.filter((item) =>
      checkForPermission(item.page?.requiredPermissions, permissions)
    );
    return filtered;
  }, [permissions, dashboardIsHome, showHistoricalLink]);

  return pages;
};
